var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileBuilderCounselor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.802,
    height: 46,
    viewBox: "0 0 42.802 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solid",
    transform: "translate(-5.92 -3.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55649",
    "data-name": "Path 55649",
    d: "M15.506,35.908A9.591,9.591,0,0,0,5.92,45.494a3.556,3.556,0,0,0,2.266,3.051,17.078,17.078,0,0,0,7.32,1.4,17.075,17.075,0,0,0,7.32-1.4,3.556,3.556,0,0,0,2.266-3.051,9.591,9.591,0,0,0-9.586-9.586Zm23.63,0a9.591,9.591,0,0,0-9.586,9.586,3.556,3.556,0,0,0,2.266,3.051,17.075,17.075,0,0,0,7.32,1.4,17.078,17.078,0,0,0,7.32-1.4,3.556,3.556,0,0,0,2.266-3.051,9.591,9.591,0,0,0-9.586-9.586Zm0-11.4a5.035,5.035,0,1,0,5.034,5.034A5.037,5.037,0,0,0,39.136,24.5Zm-23.63,0a5.035,5.035,0,1,0,5.034,5.034A5.037,5.037,0,0,0,15.506,24.5ZM32.245,11.958c0-4.379-4.2-8.015-9.464-8.015s-9.464,3.636-9.464,8.015A7.763,7.763,0,0,0,17.5,18.613l0,3.437a.821.821,0,0,0,1.4.587l2.778-2.719a11.065,11.065,0,0,0,1.108.055c5.261,0,9.464-3.636,9.464-8.015Zm-2.9-7.741a9.314,9.314,0,0,1,4.54,7.774,9.3,9.3,0,0,1-4.465,7.725,11.211,11.211,0,0,0,3.495.2l2.777,2.719a.821.821,0,0,0,1.4-.587V18.613a7.762,7.762,0,0,0,4.184-6.655c0-4.379-4.2-8.015-9.464-8.015A11.122,11.122,0,0,0,29.346,4.216Zm-10.83,6.528A1.452,1.452,0,1,1,17.064,12.2a1.452,1.452,0,0,1,1.452-1.452Zm4.308,0A1.452,1.452,0,1,1,21.372,12.2a1.452,1.452,0,0,1,1.452-1.452Zm4.308,0A1.452,1.452,0,1,1,25.68,12.2a1.452,1.452,0,0,1,1.452-1.452Z",
    fill: "#387f75",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuilderCounselor);
export default __webpack_public_path__ + "static/media/profile-builder-counselor.00601212e79dfb53083d1ccb02db68ad.svg";
export { ForwardRef as ReactComponent };